<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <ul class="chat-message__actions">
      <li
        v-for="(action, index) in chat.message_rich.actions"
        v-theme-bg-hover
        :class="checkActionState(index)"
      >
        <label
          class="date-picker"
          :for="`date-${chat.id}-${index}`"
          @click.prevent="openDateWidget"
        >
          <span>{{ action.text }}</span>
        </label>
      </li>
    </ul>
  </chat-message>
</template>

<script>
import { lineBreaks } from 'Utilities'
import { EventBus } from 'ChatWidget/EventBus'
import { defaultStartDate, defaultEndDate } from 'javascript/Constants'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'

export default {
  components: { ChatMessage },
  mixins: [chatWidgetMixin],

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore()
    }
  },

  data() {
    return {
      active: this.chat.message_rich.hasOwnProperty('active')
        ? this.chat.message_rich.active
        : true,
      actions: this.chat.message_rich.actions,
      currentDate: this.chat.message_rich.start_date || defaultStartDate,
      datePickerIsOpen: false,
      startDate: this.chat.message_rich.start_date || defaultStartDate,
      endDate: this.chat.message_rich.end_date || defaultEndDate,
      disabledDates: this.chat.message_rich.disabled_dates,
      useDateRange: this.chat.message_rich.use_date_range
    }
  },
  computed: {
    formatChatMessage() {
      return lineBreaks(this.chat.message_rich.message)
    },
    inventory() {
      let inventory = this.chat.message_rich.inventory || {}
      inventory = Object.keys(inventory).length > 0 ? inventory : null
      return inventory
    }
  },
  mounted() {
    // disable this widget on datepicker send date
    EventBus.$on('disableDateWidget', (datePickerWidgetId) => {
      if (this.chat.id === datePickerWidgetId) {
        this.disableDateWidget()
      }
    })
  },
  methods: {
    checkActionState(index) {
      if (this.actions[index].selected === true) {
        return 'choosen'
      }
      if (this.active === false) {
        return 'inactive'
      } else {
        return ''
      }
    },
    openDateWidget() {
      if (this.active) {
        // opening the date widget inside the footer at ChatWidget/ChatWindow/index.vue
        const disabledDates = {
          to: new Date(this.startDate),
          from: new Date(this.endDate)
        }

        if (this.disabledDates) {
          disabledDates['dates'] = this.disabledDates
        }

        const enabledDates = {
          dates: this.chat.message_rich.enabled_dates
        }

        this.bottomPanelStore.setBottomPanelComponent('DatePickerPanel')
        this.datepickerStore.setTimeSettings({
          currentDate: this.currentDate,
          datePickerWidgetId: this.chat.id
        })
        this.datepickerStore.setInventory(this.inventory)
        this.datepickerStore.setDateRange([])
        this.datepickerStore.enableDateRange(this.useDateRange)
        this.datepickerStore.setDisabledDates(disabledDates)
        this.datepickerStore.setEnabledDates(enabledDates)
      }
    },
    disableDateWidget() {
      this.active = false
    }
  }
}
</script>
